export default __webpack_public_path__ + "static/person-chat-f048ed31c90fb5dca6e7196f151d7ad5.svg";